module.exports = __webpack_public_path__ + "static/intro-example-64ab57b9920f1cb5c6fe06465c25a0c0.png";